import APIContainer from "../../../../../Components/Forms&Table/Tables/DataTables/API/ApiContainer";

const Api = () => {
  return <APIContainer />;
};

export default Api;
